<template>
  <div class="detail container">
    <div class="row">
      <div class="nav col-lg-4">
        <Menu></Menu>
      </div>
      <div class="col-lg-8 content col-sm-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/menu.vue'

export default {
  components: {
    Menu
  }

};
</script>

<style lang="less" scoped>
  .detail{
    height: 100%;
    .row{
      height: 100%;
    }
  }
</style>
